module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }, [_c('h1', {
    staticClass: "chap1d"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "VPS-5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/006_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/007_Chapter_1"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 1")]), _vm._v("\nThe Ancient World")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/008_Chapter_2"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 2")]), _vm._v("\n The Early Workings")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/009_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 3")]), _vm._v("\nThe Stannaries")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/010_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 4")]), _vm._v("\n Deep Mines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/011_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 5")]), _vm._v("\nTutwork, Tribute and Dressing")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/012_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 6")]), _vm._v("\nWatt and the Pirates")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/013_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 7")]), _vm._v("\nThe Health of the Miners")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/014_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 8")]), _vm._v("\nHome Life")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/015_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 9")]), _vm._v("\n Children at Work")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/016_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 10")]), _vm._v("\n Smelters and Foundries")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/017_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 11")]), _vm._v("\n The Working Men")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/018_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 12")]), _vm._v("\n Silver and Lead")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/019_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 13")]), _vm._v("\n The Cousin Jacks")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/020_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 14")]), _vm._v("\n A Changing World")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/021_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 15")]), _vm._v("\n The Camborne School of Mines")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/022_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 16")]), _vm._v("\n The Long Decline")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/023_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "hang_1"
  }, [_vm._v("Chapter 17")]), _vm._v("\n Places to Visit")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_11"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/024_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0